/*
==========================================================
AVA VISION CONTEXT
American Global
==========================================================
*/

import type { VisionResponse } from "./avaVisionUploader";

let latestVision: VisionResponse | null = null;
let latestFrame: string | null = null;

export function setLatestVision(
    vision: VisionResponse
): void {

    latestVision = {
        ...vision,
        scene: vision.scene ?? {},
    };

}

export function getLatestVision(): VisionResponse | null {

    return latestVision;

}

export function clearLatestVision(): void {

    latestVision = null;

}


export function setLatestFrame(frame: string): void {
    latestFrame = frame;
}

export function getLatestFrame(): string | null {
    return latestFrame;
}
